export const SpaceAvatar = ({ icon, color, size = "md", className = "" }) => {
  const sizes = { sm: "h-7 w-7 text-sm", md: "h-9 w-9 text-base", lg: "h-12 w-12 text-xl", xl: "h-16 w-16 text-3xl" };
  return (
    <div
      className={`flex items-center justify-center rounded-xl shrink-0 ${sizes[size]} ${className}`}
      style={{ backgroundColor: `${color}1f`, border: `1px solid ${color}40` }}
    >
      <span>{icon}</span>
    </div>
  );
};

export const UserAvatar = ({ name, color, src, size = "md", className = "" }) => {
  const sizes = { sm: "h-7 w-7 text-xs", md: "h-9 w-9 text-sm", lg: "h-14 w-14 text-lg" };
  if (src) {
    return (
      <img
        src={src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`}
        alt={name}
        className={`rounded-full object-cover shrink-0 ${sizes[size]} ${className}`}
      />
    );
  }
  const initials = (name || "?")
    .split(" ")
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
  return (
    <div
      className={`flex items-center justify-center rounded-full font-semibold text-white shrink-0 ${sizes[size]} ${className}`}
      style={{ backgroundColor: color || "#5F6368" }}
    >
      {initials}
    </div>
  );
};
